import { Box, LinearProgress, Typography, styled } from '@mui/material';

// プログレスバーのラッパー（高さとマージンを設定）
const ProgressWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

// 評価のコンテナ（フレックスでタイトルと評価を両端に配置）
const HeaderContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export interface ProgressBarComponentProps {
  title: string;
  ratingText: string;
  progressValue: number;
  descriptionText: string;
  progressColor: string;
}

export function ProgressBarComponent(props: ProgressBarComponentProps) {
  return (
    <div className="progressBar">
      <Box sx={{ width: '100%', maxWidth: 600 }}>
        <HeaderContainer>
          <Typography variant="body1" fontWeight="bold">
            {props.title}
          </Typography>
          <Typography variant="body1" fontWeight="bold" color="primary">
            {props.ratingText}
          </Typography>
        </HeaderContainer>

        <ProgressWrapper>
          <LinearProgress
            variant="determinate"
            value={props.progressValue}
            sx={{
              height: 10, // バーの高さ
              borderRadius: 5, // バーの角丸
              backgroundColor: '#e0e0e0', // バーの背景色（画像のような薄いグレー）
              '& .MuiLinearProgress-bar': {
                backgroundColor: props.progressColor, // バーの進行色（MUIのprimaryカラーを想定）
              },
            }}
          />
        </ProgressWrapper>

        {/* 補足説明テキスト (画像の下部の文章を再現) */}
        <Typography variant="body2" color="text.secondary" mt={2} mb={10}>
          {props.descriptionText}
        </Typography>
      </Box>
    </div>
  );
}
